export const getBGCButtonLabel = (status) => {
  switch (status) {
    case "WORK_IN_PROGRESS":
      return "In Progress";

    case "COMPLETED":
      return "Completed";

    case "VERIFIED":
      return "View";

    case "PENDING_SUBMISSION":
      return "Pending";

    case "YET_TO_START":
      return "Start BGC";

    default:
      return "Start BGC";
  }
};

export const isBGCButtonDisabled = (status) => {
  switch (status) {
    case "COMPLETED":
    case "PENDING_SUBMISSION":
      return true;

    case "WORK_IN_PROGRESS":
    case "VERIFIED":
    case "YET_TO_START":
    default:
      return false;
  }
};
